var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5781",
    "data-name": "Rect\\xE1ngulo 5781",
    width: 51,
    height: 51,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51521",
    "data-name": "Trazado 51521",
    d: "M2.353,3.906l.014,3.023a1.17,1.17,0,1,1-2.34.011L0,1.176A1.17,1.17,0,0,1,1.976.321l10.55,10.014a1.17,1.17,0,1,1-1.611,1.7Z",
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 11.752, 48.123)",
    fill: "#8bb3fc",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51522",
    "data-name": "Trazado 51522",
    d: "M39.419,125.494l1.9-.809a1.17,1.17,0,1,0-.918-2.152l-1.9.809a1.17,1.17,0,1,0,.918,2.152Z",
    transform: "translate(-15.184 -111.727)",
    fill: "#8bb3fc",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51523",
    "data-name": "Trazado 51523",
    d: "M57.24,113.019,39.884,120.43a1.17,1.17,0,0,1-.919-2.152L59,109.723a1.17,1.17,0,0,1,1.536,1.536L39.981,159.394a1.17,1.17,0,0,1-1.9.368L27.155,148.84a1.171,1.171,0,0,1-.118-1.516l12.582-17.3-17.87,12.067a1.17,1.17,0,0,1-1.482-.141L10.5,132.18a1.17,1.17,0,0,1,.368-1.9L28.4,122.789a1.17,1.17,0,0,1,.918,2.152L13.375,131.75l7.863,7.863,22.587-15.252a1.17,1.17,0,0,1,1.6,1.658L29.517,147.892l8.992,8.992Z",
    transform: "translate(-9.72 -109.194)",
    fill: "#8bb3fc",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.042247cb45890106c43bff93066bb311.svg";
export { ForwardRef as ReactComponent };